import React from 'react'

// A Demeanour is not just flavour text: playing your character's disposition to
// the hilt is a once-per-scene trigger that pays out one mechanical effect. The
// first three payouts are the same shapes fate points use, so they route through
// applyFateToTest(); 'negate_damage' instead zeroes the last hit that landed.
export const DEMEANOUR_EFFECTS = [
  { key: 'reroll', label: 'Re-roll the test' },
  { key: 'plus10', label: '+10 to the test' },
  { key: 'dos', label: '+1 Degree of Success' },
  { key: 'negate_damage', label: 'Negate one hit of damage' }
]

export function demeanourEffectLabel(key) {
  const found = DEMEANOUR_EFFECTS.find(e => e.key === key)
  return found ? found.label : 'No effect set'
}

// Shows the acting character's Demeanour and spends it on the most recent roll.
// `used` is true once it has been triggered in the current scene/round; the
// parent owns that bookkeeping the same way it owns Dodge/Parry reactionRound.
export default function DemeanourControls({ demeanour, used, disabled, onTrigger }) {
  if (!demeanour || !demeanour.name) return null
  const label = demeanourEffectLabel(demeanour.effect)
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-amber-300" title={`Demeanour: ${label} (once per scene)`}>
        &#9670; {demeanour.name}
      </span>
      <button
        className="rounded-xl px-3 py-1.5 text-sm bg-amber-800 hover:bg-amber-700 disabled:opacity-40"
        disabled={disabled || used || !demeanour.effect}
        onClick={onTrigger}
        title={used ? 'Demeanour already triggered this scene' : `Trigger Demeanour: ${label}`}
      >
        {used ? 'Used this scene' : label}
      </button>
    </div>
  )
}
